var map = {
	"./blog.yml": 44,
	"./cloud.yml": 45,
	"./color.yml": 46,
	"./country.yml": 47,
	"./doc.yml": 48,
	"./emoji.yml": 49,
	"./flag.yml": 50,
	"./git.yml": 51,
	"./icon.yml": 52,
	"./license.yml": 53,
	"./link.yml": 54,
	"./people.yml": 55,
	"./soft.yml": 56,
	"./src.yml": 57,
	"./status.yml": 58,
	"./svg.yml": 59,
	"./taxonomy.yml": 60
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 203;